import { Tag } from '@chakra-ui/react';
import { OpenbookStatus } from '..';

const StatusTag = ({ status }) => {
  const { colorScheme, label } = OpenbookStatus[status] ?? { colorScheme: 'gray', label: 'Unknown' };

  return <Tag colorScheme={colorScheme}>{label}</Tag>;
};

export default StatusTag;
